export const EXCMCASE_SHOW_RESET = 'EXCMCASE_SHOW_RESET'
export const EXCMCASE_SHOW_SET_ERROR = 'EXCMCASE_SHOW_SET_ERROR'
export const EXCMCASE_SHOW_SET_RETRIEVED = 'EXCMCASE_SHOW_SET_RETRIEVED'
export const EXCMCASE_SHOW_TOGGLE_LOADING = 'EXCMCASE_SHOW_TOGGLE_LOADING'
